export const currencySymbol = {
  usd: 'USD',
  aed: 'د.إ',
  afn: 'Afs',
  all: 'Lek',
  amd: '֏',
  ang: 'NAƒ',
  aoa: 'Kz',
  ars: 'Arg$',
  aud: 'A$',
  awg: 'Afl',
  azn: '₼',
  bam: 'KM',
  bbd: 'Bds$',
  bdt: '৳',
  bgn: 'лев',
  bhd: 'BD',
  bif: 'FBu',
  bmd: 'Ber$',
  bnd: 'B$',
  bob: 'Bs.',
  brl: 'R$',
  bsd: 'B$',
  bwp: 'P',
  byn: 'Br',
  bzd: 'BZ$',
  cad: 'Can$',
  cdf: 'FC',
  chf: 'CHF',
  clp: 'Ch$',
  cny: '¥',
  cop: 'Col$',
  crc: '₡',
  cve: 'Esc',
  czk: 'Kč',
  djf: 'Fdj',
  dkk: 'DKr',
  dop: 'RD$',
  dzd: 'DA',
  egp: '£E',
  etb: 'Br',
  eur: '€',
  fjd: 'FJ$',
  fkp: '£',
  gbp: '£',
  gel: 'ლ',
  gip: '£',
  gmd: 'D',
  gnf: 'GFr',
  gtq: 'Q',
  gyd: 'G$',
  hkd: 'HK$',
  hnl: 'L',
  htg: 'G',
  huf: 'Ft',
  idr: 'Rp',
  ils: '₪',
  inr: '₹',
  isk: 'IKr',
  jmd: 'J$',
  jod: 'JD',
  jpy: '¥',
  kes: 'KSh',
  kgs: 'лв',
  khr: 'CR',
  kmf: 'FC',
  krw: '₩',
  kwd: 'KD',
  kyd: 'CI$',
  kzt: '₸',
  lak: '₭',
  lbp: '£L',
  lkr: 'SL Rs',
  lrd: 'L$',
  lsl: 'L',
  mad: 'Dhs',
  mdl: 'L',
  mga: 'Ar',
  mkd: 'ден',
  mmk: 'K',
  mnt: '₮',
  mop: 'P',
  mro: 'UM',
  mur: 'MRs',
  mvr: 'MRf',
  mwk: 'MK',
  mxn: 'Mex$',
  myr: 'RM',
  mzn: 'Mt',
  nad: 'N$',
  ngn: '₦',
  nio: 'C$',
  nok: 'kr',
  npr: 'NRs',
  nzd: 'NZ$',
  omr: 'RO',
  pab: 'B/.',
  pen: 'S/.',
  pgk: 'K',
  php: '₱',
  pkr: 'Rs',
  pln: 'zł',
  pyg: '₲',
  qar: 'QR',
  ron: 'lei',
  rsd: 'дин',
  rub: 'Rbls',
  rwf: 'FRw',
  sar: 'SRls',
  sbd: 'SI$',
  scr: 'SRs',
  sek: 'SKr',
  sgd: 'S$',
  shp: '£',
  sle: 'Le',
  sos: 'Sh.So.',
  srd: 'SRD',
  std: 'Db',
  szl: 'L',
  thb: '฿',
  tjs: 'SM',
  tnd: 'DT',
  top: 'T$',
  try: '₺',
  ttd: 'TT$',
  twd: 'NT$',
  tzs: 'TSh',
  uah: '₴',
  ugx: 'USh',
  uyu: '$U',
  uzs: 'лв',
  vnd: '₫',
  vuv: 'VT',
  wst: 'WS$',
  xaf: 'fr.CFA',
  xcd: 'EC$',
  xof: 'fr.CFA',
  xpf: 'Fr',
  yer: 'YRls',
  zar: 'R',
  zmw: 'ZK',
}
